import { render, staticRenderFns } from "./image3d.vue?vue&type=template&id=f5af4d70&scoped=true"
import script from "./image3d.vue?vue&type=script&lang=js"
export * from "./image3d.vue?vue&type=script&lang=js"
import style0 from "./image3d.vue?vue&type=style&index=0&id=f5af4d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5af4d70",
  null
  
)

export default component.exports